module.exports = __webpack_public_path__ + "img/downTitle.06e262d8.png";